import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import AssessmentsForm from '../../../components/forms/AssessmentsForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function AssessmentsPageEditPage() {
  const { itemId } = useParams();
  const { requestApi, data, error } = useFetch(`/v1/admin/ratings/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <AssessmentsForm defaultValues={data?.data} /> : <Loader />;
}
